import { SelectedItem, Board, ExpandedSlap, FocusedPlace, StickerDesignId, SlapId } from '../utils/Primitives'
import { getPlaceGroupCount, getPlace } from '../places/Places'
import SlapRow from './SlapRow'
import { lookupExpandedSlap } from '../slaps/Slaps'
import LatestSlaps from '../slaps/LatestSlaps'
import GetTheLink from '../components/GetTheLink'

export type FocusedPlaceDetailsProps = {
   focusedPlace: FocusedPlace;
   boardRef: React.MutableRefObject<Board>;
   setFocusOnPlace: (place: FocusedPlace) => void;
   currentPage: number;
   setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
   handleSlapClick: (slapId: SlapId, e: React.MouseEvent<HTMLDivElement>) => void;
   handleStickerClick: (stickerDesignId: StickerDesignId, e: React.MouseEvent<HTMLDivElement>) => void;
   handleSlapCreatorOpen: () => void;
}

export default function FocusedPlaceDetails(props: FocusedPlaceDetailsProps) {
    const { focusedPlace, boardRef, setFocusOnPlace, currentPage, setCurrentPage, handleSlapClick, handleStickerClick, handleSlapCreatorOpen } = props;
    if (focusedPlace === null || focusedPlace.placeId === null) {
        return (
            <div>
                <div className='w-full mt-8 mb-4 text-base rounded bg-gray-200 text-slate-900 text-center md:hidden'>
                    Tap map to view a Place.
                </div>
                <div className='w-full mt-8 mb-4 hidden md:block md:text-base rounded bg-gray-200 text-slate-900 text-center'>
                    Click map to view a Place.
                </div>
            </div>
        );
    }

    const place = getPlace({ boardRef, placeId: focusedPlace.placeId });
    if (!place) {
        return null;
    }

    if (place.bounds) {
        const corner = place.bounds.getSouthWest()
        const apiUrl = process.env.NEXT_PUBLIC_STICKERCLOUD_API;
        let fetchUrl: string | null = null;
        if (apiUrl) {
            fetchUrl = `${apiUrl}slaps?placeId=${focusedPlace.placeId}`;
        }

        return (
            <div className='p-2 w-full mt-4 md:text-lg border-2 border-gray-300 rounded bg-gray-200 text-slate-900'>
                <div className='px-2 cursor-pointer flex items-center gap-1'>
                    <span className='capitalize pr-1'>Place</span>
                    <span>{focusedPlace.placeId}</span>
                    <GetTheLink
                        placeId={focusedPlace.placeId}
                        slapId={null}
                        stickerDesignId={null}
                    />
                </div>
                <div className='px-2 cursor-pointer'>
                    <span className='text-xs'>
                    Coordinates: {corner.lat}, {corner.lng}
                    </span>
                </div>
                {fetchUrl && (
                    <LatestSlaps
                        boardRef={boardRef}
                        fetchUrl={fetchUrl}
                        slapsPerPage={5}
                        setFocusOnPlace={setFocusOnPlace}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        handleSlapClick={handleSlapClick}
                        handleStickerClick={handleStickerClick}
                    />
                )}
            </div>
        )
    }
    return null
}
